<template>
	<div class="card card-white flex items-center justify-between space-x-4">
		<div>
			<a :href="channel.url"
			   class="text-black dark:text-white flex items-center space-x-4">
				<div class="block w-8 h-8 md:w-12 md:h-12 shrink-0">
					<avatar :ava="channel.ava" :square="1" class="w-8 h-8 md:w-12 md:h-12"></avatar>
				</div>
				<div>
					<div class="font-medium truncate">{{ channel.name }}</div>
					<div class="text-sm text-gray-500 dark:text-slate-400">
						Подписчиков: {{ channel.subscribers_count }}
					</div>
				</div>
			</a>

		</div>
		<div>
			<subscribe-button-compact
				v-if="user.check()"
				:compact="true"
				type="channel" :id="channel.id"
				:subscribed="channel.subscribed"
			></subscribe-button-compact>
		</div>
	</div>
</template>
<script>
import User from "../../js/modules/User";
import Avatar from "./Avatar.vue";
import SubscribeButtonCompact from "./SubscribeButtonCompact.vue";

export default {
	components: {SubscribeButtonCompact, Avatar},
	props: [
		'channel',
	],
	data() {
		return {
			user: new User(),
		};
	}
}
</script>
